import { BoxProps, GridProps, SxProps } from "@mui/material";
import React from "react";
import muiVariables from "../../styles/mui-variables";

const CalenderComponentStyle = {
  mainTableHeaderBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: { xs: "start", sm: "center" },
    flexDirection: { xs: "column", sm: "row" },
    sx: {
      marginBottom: "24px",
      marginTop: "40px",
    },
  } as BoxProps,
  firstGridItem: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    gap: { xs: 2 },
  } as GridProps,
  buttonStyle: {
    paddingBottom: "10px",
    "&:hover": {
      backgroundColor: "#fff",
    },
  } as SxProps,
  mainTitleTypo: {
    color: muiVariables.mainTextColor,
    fontFamily: muiVariables.mainFontFamily,
    fontSize: "20px",
    fontWeight: 700,
  } as React.CSSProperties,
  calenderStyleHeight: { height: 700 } as React.CSSProperties,
  calenderPropGetter: {
    fontFamily: muiVariables.mainFontFamily,
    fontSize: muiVariables.subHeadingFontSize,
    fontWeight: 500,
    padding: "3px 4px",
    color: muiVariables.primaryBtnColor,
    backgroundColor: muiVariables.notifyBgColor,
    borderRadius: "4px",
  } as React.CSSProperties,
};

export default CalenderComponentStyle;
